import { render, staticRenderFns } from "./page01.vue?vue&type=template&id=5a87dc80&scoped=true&"
import script from "./page01.vue?vue&type=script&lang=js&"
export * from "./page01.vue?vue&type=script&lang=js&"
import style0 from "./page01.vue?vue&type=style&index=0&id=5a87dc80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a87dc80",
  null
  
)

export default component.exports